/* eslint-disable object-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable import/no-cycle */
/* eslint-disable max-len */
import React, { memo } from "react";

import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { CAREER_TYPE_ELEARNING, CAREER_TYPE_CLASSROOM, CAREER_TYPE_CURRICULUM } from "../../../Constants";

import { Career } from "../TrainingList";
import CareerCard from "../../../component/card/CareerCard";
import CurriculumCard from "../../../component/card/CurriculumCard";
import SompoCardContent from "../../../component/card/SompoCardContent";
import NoData from "../../../component/NoData";
import { SompoSearchModeValue } from "../../../component/mode/SompoSearchMode";
import SompoLoading from "../../../component/loading/SompoLoading";

import { formatPeriod } from "../../../logic/datetime";
import SompoContext from "../../../logic/context/SompoContext";

// Domestic constants.
const TYPOGRAPHY_STYLE_CARD_DEFAULT = { fontSize: "12px" };
const TYPOGRAPHY_STYLE_CARD_TITLE = {
    width: "100%",
    fontSize: "1rem",
    fontWeight: "bold",
    minHeight: "2lh",
    WebkitLineClamp: 2,
    mb: 1,
    wordBreak: "break-all",
    overflowX: "hidden",
};
const TYPOGRAPHY_STYLE_CARD_PERIOD = {
    ...TYPOGRAPHY_STYLE_CARD_DEFAULT,
    minHeight: { md: "18px", sm: "40px", xs: "40px" },
};
const TYPOGRAPHY_STYLE_CARD_TYPE = {
    ...TYPOGRAPHY_STYLE_CARD_DEFAULT,
    minHeight: "18px",
};
const TYPOGRAPHY_STYLE_CARD_PLACE = {
    ...TYPOGRAPHY_STYLE_CARD_DEFAULT,
    wordBreak: "break-all",
    overflowX: "hidden",
};

// Interface/Types.
interface ResultsAreaProps {
    careers: Career[];
    searchMode: SompoSearchModeValue;
}

// Sub components.
const ResultAreaCardCareer = (props: { career: Career }) => {
    // Props.
    const { career } = props;

    // Hooks.
    const navigate = useNavigate();

    // Render component.
    return (
        <CareerCard
            key={career.careerId}
            thumbnail={career.careerImageUrl}
            tooltip={career.careerTitle}
            height="305px"
            badge={career.divisionId}
            onClick={() =>
                navigate(`/training/detail/${career.careerId}`, {
                    state: { classId: career.classId },
                })
            }
        >
            <SompoCardContent
                sx={{
                    width: "100%",
                    height: "auto",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    textAlign: "left",
                }}
            >
                {/** タイトル */}
                <Typography sx={TYPOGRAPHY_STYLE_CARD_TITLE} className="ellipses">
                    {career.careerTitle}
                </Typography>
                {/** 期間 */}
                <Typography sx={TYPOGRAPHY_STYLE_CARD_PERIOD}>{formatPeriod(career.period)}</Typography>
                <Typography sx={TYPOGRAPHY_STYLE_CARD_TYPE}>
                    {String(career.careerTypeId) === CAREER_TYPE_ELEARNING ? "e-ラーニング" : "集合研修"}
                </Typography>
                {String(career.careerTypeId) === CAREER_TYPE_CLASSROOM && career.placeName && (
                    <Typography className="ellipses" sx={TYPOGRAPHY_STYLE_CARD_PLACE}>
                        {career.placeName}
                    </Typography>
                )}
            </SompoCardContent>
        </CareerCard>
    );
};

const ResultAreaCardCurriculum = (props: { curriculum: Career }) => {
    // Props.
    const { curriculum } = props;

    // Hooks.
    const navigate = useNavigate();

    // Render component.
    return (
        <CurriculumCard
            tooltip={curriculum.careerTitle}
            badge={curriculum.divisionId}
            onClick={() => navigate(`/curriculum/detail/${curriculum.careerId}`)}
        >
            <SompoCardContent
                sx={{
                    height: "175px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    textAlign: "left",
                    gap: 0.4,
                }}
            >
                <Box>
                    <Typography sx={TYPOGRAPHY_STYLE_CARD_TITLE} className="ellipses2">
                        {curriculum.careerTitle}
                    </Typography>
                </Box>
                <Box>
                    <Typography variant="body2">カリキュラム</Typography>
                    <Typography variant="body2">{`${curriculum.credit || 0} 単位`}</Typography>
                </Box>
            </SompoCardContent>
        </CurriculumCard>
    );
};

// {/* fetchが終わるまでローディングアイコンを表示 */}
// Main component.
const ResultsArea = (props: ResultsAreaProps) => {
    // Context.
    const sompoContext = React.useContext(SompoContext); // ローディングアニメーションの表示用
    return sompoContext.loading ? (
        <SompoLoading mt={10} position="relative" />
    ) : (
        <Box sx={{ pt: 2 }}>
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                sx={{
                    height: "auto",
                    flexWrap: "wrap",
                    rowGap: 1.5,
                    width: "100%",
                    pb: 1,
                    mt: 1,
                }}
            >
                {(props.careers || []).length ? (
                    <>
                        {props.careers.map((row) => {
                            const id = `${row.careerId}-${row.classId}`;
                            return (
                                <Grid sx={{ mx: 0.5 }} key={`TrainingList-Result-Card-Container-${id}`}>
                                    {(() => {
                                        const key = `TrainingList-Result-Card-${id}`;
                                        switch (String(row.careerTypeId)) {
                                            case CAREER_TYPE_ELEARNING:
                                            case CAREER_TYPE_CLASSROOM:
                                                return <ResultAreaCardCareer key={key} career={row} />;

                                            case CAREER_TYPE_CURRICULUM:
                                                return <ResultAreaCardCurriculum key={key} curriculum={row} />;

                                            default:
                                                return <></>;
                                        }
                                    })()}
                                </Grid>
                            );
                        })}
                    </>
                ) : (
                    <NoData message="表示データがありません" />
                )}
            </Grid>
        </Box>
    );
};

export default memo(ResultsArea);
